import moment from 'moment';

/**
 * valida se o email e valido
 * @param {*} email 
 */
export function validateEmail(email) {
    if(!email)
        return false;

    let qtdStrLocal = email.split("@")[0].length;
    let strDominio = email.split("@")[1];
    
    if(qtdStrLocal <=64) {

        if(strDominio) {
            if(strDominio.split(".").length < 2) {
                return false;
            }
        }

        var emailPattern = /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/
        return emailPattern.test(email);
    } else {
        return false;
    }
}

/**
 * header para chamadas na api
 */
export const headers = {
    headers: {
        'Application-Id': 2,
        'Application-Secret': '$2y$10$c0aexjzdcu.uvJUH.a0YZ.q.DymR4VYhKUvhjk4lPj9R8C2h7SKvK'
    }
};

/**
 * valida se cpf e valido
 * @param {*} cpf 
 */
export function validaCPF(strCPF) {
    let add;
    let rev;
    let i;
    strCPF = strCPF.replace(/[^\d]+/g, '');
    if (strCPF === '') return false;
    if (strCPF.length !== 11 ||
        strCPF === "00000000000" ||
        strCPF === "11111111111" ||
        strCPF === "22222222222" ||
        strCPF === "33333333333" ||
        strCPF === "44444444444" ||
        strCPF === "55555555555" ||
        strCPF === "66666666666" ||
        strCPF === "77777777777" ||
        strCPF === "88888888888" ||
        strCPF === "99999999999")
        return false;
    add = 0;
    for (i = 0; i < 9; i++)
        add += parseInt(strCPF.charAt(i)) * (10 - i);
    rev = 11 - (add % 11);
    if (rev === 10 || rev === 11)
        rev = 0;
    if (rev !== parseInt(strCPF.charAt(9)))
        return false;
    add = 0;
    for (i = 0; i < 10; i++)
        add += parseInt(strCPF.charAt(i)) * (11 - i);
    rev = 11 - (add % 11);
    if (rev === 10 || rev === 11)
        rev = 0;
    if (rev !== parseInt(strCPF.charAt(10)))
        return false;
    return true;
}

/**
 * cria máscara para exibição de cpf
 * @param {*} cpf 
 */
export function formatCpf(cpf) {
    if (!cpf) {
        return "";
    }
    let cpfMask;
    return cpfMask = cpf.substring(0, 3) + "." + cpf.substring(3, 6) + "." + cpf.substring(6, 9) + "-" + cpf.substring(9, 11);
}


/**
 * oculta caracteres do cpf
 * @param {*} cpf 
 */
export function maskCpf(cpf) {
    if (!cpf) {
        return "";
    }

    let cpfClean = cpf.replace(/[^\d]/g, "");
    return cpfClean.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.***.***-$4");
}

export function formatNumber(number) {
    if (!number) {
        return "";
    }

    let numberClean = number.replace(/[^\d]/g, "");
    let numberOut = number;

    if (number.length === 10) {
        numberOut = numberClean.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
    }

    if (number.length === 11) {
        numberOut = numberClean.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
    }

    return numberOut
}


/**
 * cria máscara para exibição de data
 * @param {*} date 
 */
function formatDate(birthDate) {
    if (birthDate) {
        let str = birthDate.split(" ")[0].split("-")
        let strDay = str[2]
        strDay = strDay.split(" ")[0].split("T")
        return strDay[0] + "/" + str[1] + "/" + str[0]
    }
}

/**
 * cria máscara para exibição de hora
 * @param {*} date 
 */
function formatHour(birthDate) {
    if (birthDate) {
        let strHourFormat = moment.utc(birthDate).subtract(3, 'hours').format('HH:mm');
        return strHourFormat.replace(':', 'h');
    }
}

/**
 * cria validação para permitir apenas letras.
 * @param {*} str 
 */
function validateName(str) {
    let regex = /^[a-záàâãéèêíïóôõöúçñ]+$/i;
    let valid = str.split(/ +/).every(str => regex.test(str));
    return valid;
}

/**
 * Cria validação de DDD para telefone
 * @param {*} phone 
 */
function validateDDD(phone) {
    var regex = new RegExp('^((1[1-9])|([2-9][0-9]))((3[0-9]{3}[0-9]{4})|(9[0-9]{3}[0-9]{5}))$');
    return regex.test(phone);
}

function getCurrentYear() {
    const currentYear = moment().format('YYYY');
    return currentYear;
}

function countPasswordParameter(password){
    let countLowerCase = 0;
    let countUpperCase = 0;
    let countDigits = 0;
    let countSpecialChar = 0;
    let countNumber = password.length;

    for(let i=0; i <= password.length-1; i++) {
        if( Number.isInteger( parseInt(password[i]) ) ) {
            countDigits += 1;
        } else if( /[^a-zA-Z0-9\-\/]/.test( password[i] )  ) {
            countSpecialChar += 1;
        } else if(password[i] == password[i].toUpperCase()) {
            countUpperCase += 1;
        } else if(password[i] == password[i].toLowerCase()) {
            countLowerCase += 1;
        }
    }

    return {
        'countDigit': countDigits,
        'countSpecialChar': countSpecialChar,
        'countUpperCase': countUpperCase,
        'countLowerCase': countLowerCase,
        'countNumber': countNumber
    }
}

function createMsgPassword(parameters){
    let msgCounterNumber = "Sua senha deve conter " + parameters?.count_number + " número";
    let msgLowerCase = "Sua senha deve conter " + parameters?.lowercase_letter + " letra minúscula";
    let msgUpperCase = "Sua senha deve conter " + parameters?.uppercase_letter + " letra maiúscula";
    let msgSpecialCharacter = "Sua senha deve conter " + parameters?.special_character + " caracteres especiais";
    let msgMinimumSize = "Sua senha deve ter o mínimo de " + parameters?.minimum_size + " caracteres";
    let msgConfirmPassword = "As senhas devem ser iguais em ambos os campos";

    return {
        'msgCounterNumber': msgCounterNumber,
        'msgLowerCase': msgLowerCase,
        'msgUpperCase': msgUpperCase,
        'msgSpecialCharacter': msgSpecialCharacter,
        'msgMinimumSize': msgMinimumSize,
        'msgConfirmPassword': msgConfirmPassword
    }
}

function validatePasswordParams(countParameters, parameters, password, confirmPassword){
    let countNumberIsValid = false;
    let lowerCaseLettersIsValid = false;
    let upperCaseLettersIsValid = false;
    let specialCharLettersIsValid = false;
    let hasMininumSizeIsValid = false;
    let confirmPasswordIsValid = false;
    if(countParameters.countDigit >= parameters?.count_number) {
        countNumberIsValid = true;
    }
    
    if(countParameters.countLowerCase >= parameters?.lowercase_letter) {
        lowerCaseLettersIsValid = true;
    }

    if(countParameters.countUpperCase >= parameters?.uppercase_letter) {
        upperCaseLettersIsValid = true;
    }

    if(countParameters.countSpecialChar >= parameters?.special_character) {
        specialCharLettersIsValid = true;
    }

    if(countParameters.countNumber >= parameters?.minimum_size) {
        hasMininumSizeIsValid = true;
    }

    if(password === confirmPassword && password!=""){
        confirmPasswordIsValid = true;
    }

    return {
        'countNumberIsValid': countNumberIsValid,
        'lowerCaseLettersIsValid': lowerCaseLettersIsValid,
        'upperCaseLettersIsValid': upperCaseLettersIsValid,
        'specialCharLettersIsValid': specialCharLettersIsValid,
        'hasMininumSizeIsValid': hasMininumSizeIsValid,
        'confirmPasswordIsValid': confirmPasswordIsValid
    } 
}

function passwordParamsOffId(){
    return {
        "lowercase_letter": 0,
        "uppercase_letter": 1,
        "count_number": 0,
        "special_character": 1,
        "minimum_size": 6
    }
}

function filterDataToDevPartner(data){
    const APPLICATION_PLACE_ID = 3;
    const APPLICATION_DEVPORTAL_ID = 23;
    const APPLICATION_PLACE_ROLE_CLIENT_ID = 6;

    let applications = data.filter(obj => obj.id == APPLICATION_PLACE_ID || obj.id == APPLICATION_DEVPORTAL_ID);

    let application_place = applications.filter(obj => obj.id == APPLICATION_PLACE_ID);
    let roles_place = [];
    let roles_place_filtered = [];

    if (application_place.length == 0){
        return applications;
    }

    roles_place = application_place[0].roles;
    roles_place_filtered = roles_place.filter(obj => obj.id == APPLICATION_PLACE_ROLE_CLIENT_ID);

    applications.forEach( (obj) => {
        if (obj.id == APPLICATION_PLACE_ID) {
            obj.roles = roles_place_filtered
        }
    });

    return applications;
}

function isDevPartner(partner){

    if (partner.client) {
        return false;
    }

    return partner.devpartner;
}

export default {
    headers,
    validaCPF,
    validateEmail,
    formatCpf,
    maskCpf,
    formatNumber,
    formatDate,
    formatHour,
    validateName,
    validateDDD,
    getCurrentYear,
    passwordParamsOffId,
    countPasswordParameter,
    createMsgPassword,
    validatePasswordParams,
    filterDataToDevPartner,
    isDevPartner
}
